//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The search order options available in the Content Collection View block. */
export const SearchOrder = {
    /** The most relevant will be displayed first, this is based on the score. */
    Relevance: 0,

    /** The document with the highest relevance date time will be displayed first. */
    Newest: 1,

    /** The document with the oldest relevance date time will be displayed first. */
    Oldest: 2,

    /**
     * The most popular documents will be displayed first. This is determined
     * by the trending values and will then fall back to best match.
     */
    Trending: 3,

    /** The documents will be displayed alphabetically, A-Z. */
    Alphabetical: 4
} as const;

/** The search order options available in the Content Collection View block. */
export const SearchOrderDescription: Record<number, string> = {
    0: "Relevance",

    1: "Newest",

    2: "Oldest",

    3: "Trending",

    4: "Alphabetical"
};

/** The search order options available in the Content Collection View block. */
export type SearchOrder = typeof SearchOrder[keyof typeof SearchOrder];
